
import React from 'react';
import {
  DwollaFundingSourceStates,
  is_master_account,
  MAX_DWOLLA_PAYMENT_SOURCES,
} from "../../../lib/dwolla/constants";
import { count_funding_sources } from "../../../lib/dwolla/utils";
import {DEVICE_WIDTH, SUPER_ADMIN} from "../../../lib/constants";
import {loadDwolla, VerifyMicroPayments} from "../../payment/actions";
import { OptionPopupButton } from "../BannerMenu/OptionPopupButton";
import { PaymentsContainer2 } from "./common";
import { SetFundingSourceDefault, RemoveFundingSource } from "../../payment/actions";
import {Action, HighlightRects, Info, Spinner, TextLoading} from "../../funcs/utils";
import { add_funding_source, render_ach_flow } from "./add_funding_source_card";
import { deep_copy } from "../../../lib/js-utils";
import { Text } from "../../../lib/prm/text";
import { Name } from "../../../lib/prm/name";
import { Modal2 } from "../modal";
import {FlowRender} from "../../../lib/flow-render";
import {price_string_to_cents} from "../../../lib/currency-utils";
import {MX_STATE} from "../../payment/mx-connect";

const MICRO_DEPO_0 = new Text(new Name("MICRO_DEPO_0"));
const MICRO_DEPO_1 = new Text(new Name("MICRO_DEPO_1"));

const onMicroChange = (text_prm, orig_state, new_state) => {
  if (text_prm.getValue(orig_state) === "" && text_prm.getValue(new_state).match(/^[1-9]$/)) {
    text_prm.setValue(new_state, "0.0" + text_prm.getValue(new_state));
  }
}
const onMicroDepCB = (component, new_state, prm) => {

  if (prm === MICRO_DEPO_0) {
    onMicroChange(MICRO_DEPO_0, component.state, new_state);
  } else if (prm === MICRO_DEPO_1) {
    onMicroChange(MICRO_DEPO_1, component.state, new_state);
  }
}

MICRO_DEPO_0.onChangeCallback = onMicroDepCB;
MICRO_DEPO_1.onChangeCallback = onMicroDepCB;

const ALL_PRMS = new FlowRender(0, [
  MICRO_DEPO_0,
  MICRO_DEPO_1,
]);

const set_default_payment_source = (component, funding_source_id) => {

  SetFundingSourceDefault(
    component.props.token,
    component.props.onboarding_token,
    funding_source_id)
    .then(({dwolla}) => {
      component.setState({ source_loading: "" });
      component.props.dwollaUpdate(dwolla, 0);
      component.setState({dwolla});
  });
};

const remove_funding_source = (component, funding_source_id) => {
  component.setState({ source_loading: funding_source_id });

  RemoveFundingSource(
    component.props.token,
    component.props.onboarding_token,
    funding_source_id)
    .then(result => {
      const dwolla = result.dwolla;
      component.setState({ source_loading: "" });
      component.props.dwollaUpdate(dwolla, 0);
      component.setState({dwolla});
    })
};

const render_action_button = (component, funding_source_id, source, num_sources) => {
  const icon_style = {
    fontSize: "1.5rem",
    fontWeight: "bold",
    paddingLeft: "0.5rem",
  }
  const icon_span = {
    display: "inline-block",
    transform: "translate(0, 0.3rem)",
  };
  const is_loading = component.state.source_loading === funding_source_id;

  const buttons = [];

  if (!is_loading) {
    if (source.default && num_sources === 1) {
      buttons.push(
        { id: "remove", label: "Remove Account" });
    } else if (!source.default) {
      buttons.push(
        { id: "make_default", label: "Make Default" });
      buttons.push(
        { id: "remove", label: "Remove Account" });
    }
  }

  const action_style = {
    fontWeight: "bold",
  };
  if (source.default) {
    action_style.fontSize = "1.2rem";
  }

  const popup_style = {
    transform: "translate(-1rem, 0)",
    fontSize: "1rem",
  };
  const menu_button_style = {
    padding: "0.2rem 0.5rem",
    fontWeight: "bold",
    textAligh: "left",
  }
  const on_click = (menu_id, button_id) => {
    if (button_id === "make_default") {
      component.setState({ source_loading: funding_source_id });
      set_default_payment_source(component, funding_source_id);
    } else if (button_id === "remove") {
      remove_funding_source(component, funding_source_id);
    }

  };

  let text;
  if (is_loading) {
    text = (<Spinner/>);
  } else {
    if (source.default) {
      text = "Default";
    } else {
      text = "Action";
    }
  }

  return (
    <OptionPopupButton
      menu_id={"action"}
      popup_style={popup_style}
      on_click={on_click}
      buttons={buttons}
      menu_button_style={menu_button_style}
      button_style={{paddingRight: "1rem"}}>
      <div>
        <span style={action_style}>{ text }</span>
        <span style={icon_span}><i className="fa fa-angle-down" style={icon_style}/></span>
      </div>
    </OptionPopupButton>
  )
};

const TitleValue = props => {
  const label_style = {
    fontSize: "1rem",
  }
  const value_style = {
    fontSize: props.do_medium ? "1rem" : "1.2rem",
    fontWeight: "600",
    color: props.default ? "#000" : "#AAA",
  }
  return (
    <div>
      <div style={label_style}>
        { props.title }
      </div>
      <div style={value_style}>
        { props.value }
      </div>
    </div>
  )
}

const last_4_digits = str => {
  let result = "";

  for(let i=0; i < str.length; i++) {
    if (i < str.length - 4) {
      result += "*";
    } else {
      result += str[i];
    }
  }
  return result;
}

const PaymentSource = props => {
  const source = props.source;
  const num_sources = props.num_sources;
  const component = props.component;
  const do_medium = component.props.app.width < DEVICE_WIDTH.medium;

  const container_style = {
    padding: do_medium ? "0.5rem" : "1rem",
    margin: "1rem 0",
    border: "1px solid black",
  }

  let routing_acct = source.routing_number && source.account_number
    ? (
      <div style={{ display: "flex", marginTop: "1rem"}}>
        <div style={{flex: "1"}}>
          <TitleValue
            title={"ABA/Routing Number"}
            value={last_4_digits(source.routing_number)}
            default={source.default}/>
        </div>
        <div style={{flex: "1"}}>
          <TitleValue
            title={"Account Number"}
            value={last_4_digits(source.account_number)}
            default={source.default}/>
        </div>
      </div>
    )
    : null;

  let microdep_line;

  const on_verify = (source_id) => () => {
    component.setState({
      verify_micropayments_popup: source_id,
      verify_micropayments_error: "",
      highlight_rects: [],

    });
  }

  if (source.state === DwollaFundingSourceStates.UNVERIFIED
    && source.events
    && source.events.customer_microdeposits_completed) {
    const text = "** Two microdeposits were sent to your account. **";
    microdep_line = (
      <div>
        <div style={{ display: "flex", marginTop: "1rem", justifyContent: "center"}}>
          <div>{text}</div>
        </div>
        <div style={{ display: "flex", marginTop: "1rem", justifyContent: "center"}}>
          <Action onClick={on_verify(source.id)}>Verify Microdeposits</Action>
        </div>
      </div>
    );
  } else if (source.state === DwollaFundingSourceStates.UNVERIFIED
    && source.events
    && source.events.customer_microdeposits_added) {
    const text = "** Microdeposits are pending **";
    microdep_line = (
      <div style={{ display: "flex", marginTop: "1rem", justifyContent: "center"}}>
        <div>{text}</div>
      </div>
    )
  }

  return (
    <div style={container_style}>
      <div style={{display: do_medium ? "block" : "flex"}}>
        <div style={{ flex: "1"}}>
          <div style={{display: "flex"}}>
            <div style={{ flex: "1"}}>
              <TitleValue
                do_medium={do_medium}
                title={"Account Name"}
                value={source.name}
                default={source.default}/>
            </div>
            <div>
              { do_medium && render_action_button(component, source.id, source, num_sources) }
            </div>
          </div>
        </div>
        <div style={{flex: "1"}}>
          <div style={{display: "flex"}}>
            <div style={{flex: "1"}}>
              <TitleValue
                do_medium={do_medium}
                title={"Bank"}
                value={source.bank_name}
                default={source.default}/>
            </div>
            <div>
              { !do_medium && render_action_button(component, source.id, source, num_sources) }
            </div>
          </div>
        </div>
      </div>
      { routing_acct }
      { microdep_line }
    </div>
  );
}

const maybe_render_verify_micropayments = (component, source_id) => {
  if (component.state.verify_micropayments_popup !== source_id)  {
    return null;
  }

  const on_close = () => {
    component.setState({
      verify_micropayments_popup: "",
      is_micro_verify: false,
    })
  }

  const header = (<div style={{width: "100%"}} align={"center"}>Verify Microdeposits</div>);
  const button_list = [
    {
      label: "Cancel",
      cb: on_close,
    },
    {
      label: (
        <TextLoading
          label={"Verify"}
          loading={component.state.is_micro_verify}/>),
      cb: on_micro_verify(component, source_id),
    }
  ]
  const on_highlight_click = () => {
    component.setState({ highlight_rects: [] });
  }
  const text_0 = component.state.verify_micropayments_error
    ? (<span style={{color: "red"}}>{component.state.verify_micropayments_error}</span>)
    : (<span>Enter the two microdeposits below.</span>);

  const input_style = {
    width: "100%",
    textAlign: "center"
  }
  return (
    <Modal2
      container_style={{width: "20rem"}}
      show={true}
      onDismiss={on_close}
      header={header}
      buttonList={button_list}>
      <div ref={component.dialog_ref} style={{position: "relative"}}>
        <HighlightRects
          rects={component.state.highlight_rects}
          container_ref={component.dialog_ref}
          onClick={on_highlight_click}/>
        <div>
          <div>{text_0}</div>
          <div style={{height: "1rem"}}/>
          { MICRO_DEPO_0.renderInputDiv(component, input_style, "Microdeposit") }
          { MICRO_DEPO_1.renderInputDiv(component, input_style, "Microdeposit") }
        </div>
      </div>
    </Modal2>
  )
}


const dump_payment_cards = component => {

  const is_admin = component.props.user.account_type === SUPER_ADMIN;
  const dwolla = is_admin
    ? component.state.dwolla
    : (component.props.dwolla && component.props.dwolla['0000']);
  if (!dwolla) {
    return;
  }
  const account_type = component.props.user.account_type;

  const sources = [];
  if (dwolla.funding_source) {
    Object.keys(dwolla.funding_source).sort().forEach(id => {
      const source = deep_copy(dwolla.funding_source[id]);
      source.id = id;
      if (is_master_account(source.name) && account_type === SUPER_ADMIN) {
        sources.push(source);
      } else if (!is_master_account(source.name)) {
        sources.push(source);
      }
    });
  }

  return (
    <div>
      { sources.map(source => {
        return (
          <div key={source.id}>
            <PaymentSource
              source={source}
              component={component}
              num_sources={sources.length}/>
            { maybe_render_verify_micropayments(component, source.id) }
          </div>
        );
      }) }
    </div>
  )
}

const do_load_dwolla = (component) => {
  loadDwolla(
    component.props.token,
    component.props.onboarding_token,
    component.props.username,
    0)
    .then(dwolla => {
      component.setState({dwolla})
    });
}

const on_micro_verify = (component, source_id) => () => {

  const highlight_rects = [];
  MICRO_DEPO_0.isFilledElseHighlight(component.state, highlight_rects);
  MICRO_DEPO_1.isFilledElseHighlight(component.state, highlight_rects);

  if (highlight_rects.length > 0) {
    component.setState({ highlight_rects });
    return;
  }
  component.setState({
    is_micro_verify: true,
    verify_micropayments_error: "",
  })
  VerifyMicroPayments(
    component.props.token, null, source_id,
    price_string_to_cents(MICRO_DEPO_0.getValue(component.state)),
    price_string_to_cents(MICRO_DEPO_1.getValue(component.state)))
    .then(result => {
      component.setState({
        is_micro_verify: false,
      });
      if (result.success) {
        component.props.dwollaUpdate(result.dwolla, 0);
        component.setState({
          verify_micropayments_popup: "",
        })
      } else {
        console.log("Error", result);
        component.setState({
          verify_micropayments_error: result.message,
        })
      }

    })
}

const FundingSources = props => {

  const component = props.component;
  const args = component.props.args;
  const is_admin = component.props.user.account_type === SUPER_ADMIN;
  const dwolla = is_admin
    ? component.state.dwolla
    : (component.props.dwolla && component.props.dwolla['0000']);
  const num_sources = dwolla ? count_funding_sources(dwolla) : 0;
  const flow = args.flow;

  let add_source, header_text;

  const do_medium = component.props.app.width < DEVICE_WIDTH.medium;

  if (!flow && dwolla && num_sources < MAX_DWOLLA_PAYMENT_SOURCES) {
    add_source = (
      <div>
        <div style={{height: "2rem"}}/>
        <div style={{ display: "flex", justifyContent: "center"}}>
          <div>
            { add_funding_source(component) }
          </div>
        </div>
      </div>
    );
  } else if (num_sources >= MAX_DWOLLA_PAYMENT_SOURCES) {
    const text = "Only 2 funding source accounts are allowed. Remove one to add a new one.";
    const style = {
      display: "inline",
      fontWeight: "bold",
    }
    if (do_medium) {
      style.fontSize = "1rem";
    } else {
      style.float = "right";
    }
    header_text = (
      <div style={style}>
        { text }
      </div>
    )
  }

  const info_text = "You can set a default funding source to transfer money into your investment accounts.";

  const info = (
    <Info
      id={"funding_sources"}
      text={info_text}
      popup_style={{ width: "30rem" }}
      style={{fontSize: do_medium ? "1rem" : "1.5rem"}}
      component={component}/>
  )

  const device = {
    width: component.props.app.width,
  }

  return (
    <PaymentsContainer2
      client={component.props.client}
      device={device}
      suffix={info}
      header={header_text}
      title={"Funding Sources"}>
      { dump_payment_cards(component) }
      { add_source }
      { flow === "ach" && render_ach_flow(component) }
    </PaymentsContainer2>
  )
};

const funding_source_state = component => {
  const state = {
    verify_micropayments_popup: "",
    verify_micropayments_error: "",
    is_micro_verify: false,
    mx_flow: MX_STATE.INIT,
  }
  ALL_PRMS.init(state, {}, component);
  return state;
};

export { FundingSources, do_load_dwolla, funding_source_state }